import * as React from 'react';

import Navbar from "../../Layouts/Navbar";
import { BiSearchAlt, BiSolidCarBattery} from "react-icons/bi";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import Header from "../../Layouts/Header";
import {CiBarcode} from "react-icons/ci";
import {BsChevronCompactLeft} from "react-icons/bs";
import {HiOutlineQrcode} from "react-icons/hi";
import {LiaApple} from "react-icons/lia";
import {GiElectric} from "react-icons/gi";
import {TbStatusChange} from "react-icons/tb";
import {LuCalendarClock} from "react-icons/lu";
import ScanQR from "./ScanQR";
import {CgDanger} from "react-icons/cg";
import {IoCheckmarkDoneOutline} from "react-icons/io5";

export default function Home() {


    const [code, setCode] = React.useState('');
    const [isLoaded, setIsLoaded] = React.useState(true);
    const [showScan, setShowScan] = React.useState(false);
    const [data, setData] = React.useState(null);
    const [code2, setCode2] = React.useState('');

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

    }, []);


    const onButtonClick = () => {
        if(code.length < 13) {
            toast.error('کد باتری را کامل وارد کنید')
            return false
        }
        setIsLoaded(false);
        API.searchProduct(code)
            .then((response) => {
                setData(response.data)
                setIsLoaded(true);

            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }

    const onUpdateStatusClick = () => {
        if(code.length < 13) {
            toast.error('کد باتری را کامل وارد کنید')
            return false
        }
        const request = {
            code,
            status_id: 19
        }
        setIsLoaded(false);
        API.updateStatus(request)
            .then((response) => {
                toast.success(response.message);
                setIsLoaded(true);
                setCode('')
                setData(null)
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }


    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header hasBack={false} title='NGKH'  />


            <div className="modal fade rtl " id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-center">
                            <h5 className="modal-title text-small-1 fw-bold  text-primary" id="exampleModalLabel">
                                اسکن بارکد
                            </h5>

                        </div>
                        <div className="modal-body">
                            {
                                showScan ? <ScanQR setCode={setCode2} setShowScan={setShowScan} /> :

                                    <div className='alert alert-success text-center text-small-2 fw-bold'>
                                        کد اسکن شده:
                                        &nbsp;
                                        <div className='text-big-3 mt-2 text-dark'>{code2}</div>

                                    </div>
                            }

                        </div>
                        <div className="modal-footer">
                            {
                                !showScan ?
                                    <div>
                                        <button type="button" className="btn btn-secondary text-small-2"
                                                onClick={() => {
                                                    setShowScan(true)
                                                }}
                                        >
                                            اسکن مجدد
                                        </button>
                                        <button type="button" data-dismiss="modal" className="btn btn-success text-small-2 mx-2"
                                                onClick={() => {
                                                    setCode(code2)
                                                    setShowScan(false)

                                                }}
                                        >
                                            تایید
                                        </button>
                                    </div>
                                    :  <button type="button" data-dismiss="modal" className="btn btn-danger text-small-2 mx-2"
                                               onClick={() => {

                                                   setShowScan(false)

                                               }}
                                    >
                                        انصراف
                                    </button>
                            }


                        </div>
                    </div>
                </div>
            </div>

            <section className="section mt-4 rtl mt-4 pt-5">
                <div className="row mx-2 pb-5 mb-5">
                    <div className="col-12">

                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">
                                    <BiSearchAlt className='mx-2' />
                                    جستجو و مشاهده اطلاعات باتری
                                </h5>
                                <div className='mt-4 ltr'>
                                    <div className="input-group flex-nowrap">
                                        <button className="input-group-text"
                                                data-toggle="modal" data-target="#exampleModal"
                                                onClick={() => {
                                                    setShowScan(true)
                                                }}

                                        >
                                            <CiBarcode className='text-big-4 blink'
                                            />
                                        </button>
                                        <input type="number" className="form-control text-center text-small-1" placeholder="کد یکتای باتری" aria-label="کد یکتای باتری" aria-describedby="addon-wrapping"
                                               value={code}
                                               onChange={(val) => {
                                                   if(val.target.value.length > 14) return
                                                   setCode(val.target.value)
                                               }}
                                        />
                                    </div>
                                    <div className="row rtl mt-3 pt-2">
                                        <div className="col-2">

                                        </div>

                                        <div className="col-12">
                                            <button className='btn btn-warning w-100 text-small-2 text-white text-center ps-1'
                                                    disabled={code.length !== 14}
                                                    onClick={onButtonClick}
                                            >
                                                <BiSolidCarBattery className='text-big-4 float-end'
                                                />

                                                مشاهده اطلاعات باتری
                                                <BsChevronCompactLeft className='text-big-4 float-start'
                                                />
                                            </button>
                                        </div>
                                        <div className="col-2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 mt-3">

                        <div className="card">
                            {
                                data &&
                                <div className="card-body py-4">

                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <HiOutlineQrcode />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            کد یکتای باتری:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                            {data?.code}
                                        </div>
                                    </div>


                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <LiaApple />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            برند:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                            {data?.brand}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <GiElectric />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            آمپراژ:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                            {data?.properties[0]?.amperage}
                                            <span className='me-2 text-small-2 text-muted'>
                                                آمپر
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <TbStatusChange />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            وضعیت:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2"
                                             style={{color: data?.status?.color}}
                                        >
                                            {data?.status?.title}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <LuCalendarClock />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            تاریخ پایان گارانتی:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                            {data?.warranty_end_date}
                                        </div>
                                    </div>


                                </div>
                            }
                        </div>

                    </div>

                    {
                        data?.status?.id !== 10 && data?.status?.id !== 19 &&

                        <div className="col-12 mt-3">
                            {
                                data &&
                                <div className="py-4">
                                    <div className="alert alert-danger text-center text-small-2">
                                        <CgDanger className='mx-2 text-big-3' />
                                   امکان تایید این باتری وجود ندارد.
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    {
                        data?.status?.id === 19 &&

                        <div className="col-12 mt-3">
                            {
                                data &&
                                <div className="py-4">
                                    <div className="alert alert-info text-center text-small-2">
                                        <CgDanger className='mx-2 text-big-3' />
                                     این باتری پیش از این توسط شما تایید شده است
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    {
                        data?.status?.id === 10 &&

                        <div className="col-12 mt-3">
                            <button className='btn btn-success w-100 text-small-2 text-white text-center ps-1'
                                    onClick={onUpdateStatusClick}
                            >
                                <BiSolidCarBattery className='text-big-4 float-end'
                                />

                                تایید باتری
                                <IoCheckmarkDoneOutline className='text-big-4 float-start'
                                />
                            </button>
                        </div>
                    }
                </div>
            </section>


            <Navbar />
        </React.Fragment>
    );
};
